import { emailValidator, textValidator } from '@utils/validations/constants';
import { isNumberAndNotIncludesPlus } from '@utils/validations/is-number-and-not-includes-plus';
import { numberEndsWithPlus } from '@utils/validations/number-ends-with-plus';
import { numberStartsWithPlus } from '@utils/validations/number-starts-with-plus';

export const createMultiInviteTextRows = (
  text: string
): { row: number; fullName: string; numTickets: string | 1; email: string | null }[] => {
  const lines: string[] = text.trim().split('\n');
  return lines.map((line: string, index) => {
    const parts: string[] = line.trim().split(/\s+/);
    let nameSurname: string = '';
    let quantity: number | null = null;
    let email: string | null = null;

    parts.forEach((part) => {
      if (emailValidator.test(part)) {
        email = part;
      } else if (isNumberAndNotIncludesPlus(part)) {
        quantity = Number.parseInt(part);
      } else if (numberEndsWithPlus(part)) {
        quantity = Number.parseInt(part.substring(0), 10) + 1;
      } else if (numberStartsWithPlus(part)) {
        quantity = Number.parseInt(part.substring(1), 10) + 1;
      } else if (textValidator.test(part)) {
        nameSurname += `${part} `;
      }
    });

    return {
      row: index + 1,
      fullName: nameSurname.trim(),
      numTickets: quantity ?? 1,
      email,
    };
  });
};
